
const digest = 'd465eae75fdf7ee9ad8d84bd85817d11ac6992dffb5ef25cc6e378269ad1da9c';
const classes = {"label":"_label_vffm3_1"};
const css = `._label_vffm3_1 {
  font-size: 12px;
  margin-bottom: 10px;
  color: #9ea0a5;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  